var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEduJobFair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 703.4 247.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f1f1f1;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        stroke: #f1f1f1;\n        stroke-width: .2px;\n      }\n\n      .st2, .st3 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st3 {\n        stroke: #e50d10;\n        stroke-width: 4px;\n      }\n\n      .st4 {\n        fill: #e50d10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "8.7 204.5 682 187.1 702.2 207 681.6 230.5 8.4 247.9 8.7 204.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4,192.4l1.3-145.8,48.3-1.3-.2,17.7-28.8.8-.4,44.3,25.6-.7-.2,17.7-25.6.7-.4,48.5,28.8-.8-.2,17.7-48.3,1.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3,190.8l1.3-145.8,33.9-.9c18.3-.5,27.3,8.6,27.1,27.3l-.8,96.6c-.1,14.1-8,21.3-23.5,21.7l-37.9,1ZM88.9,172.7l14.6-.4c5.1-.1,7.7-2.4,7.8-6.7l.8-93.4c0-7-2.8-10.5-8.6-10.3l-13.6.4-1,110.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,41.5l-1,118.1c-.2,18.4-8.1,27.8-23.8,28.2l-16.4.4c-15.6.4-23.2-8.7-23.1-27.2l1-117.9,19.5-.5-1,118.6c0,6.4,2.8,9.5,8.4,9.3l7.9-.2c5.3-.1,7.9-3.4,8-9.7l1-118.6,19.5-.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.3,168.8l12.8-.3c5.8-.2,8.8-3.7,8.8-10.8l1-117.5,19.5-.5-1.1,121.2c-.1,16.4-7.7,24.8-22.7,25.2l-18.5.5.2-17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.8,184.3c-15.7.4-23.5-7.6-23.3-24.2l.8-96c.1-16.6,8-25.2,23.5-25.6l18.7-.5c15.5-.4,23.3,7.7,23.1,24.4l-.8,96c-.1,16.5-8.1,25-23.7,25.4l-18.3.5ZM324.7,166.5l9.9-.3c5.1-.1,7.7-3,7.8-8.7l.8-93.4c0-5.7-2.8-8.5-8.6-8.3l-9.1.2c-5.7.1-8.5,3.1-8.6,8.7l-.8,93.4c0,5.7,2.8,8.5,8.6,8.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.5,106.9c10.7,2.7,15.9,8.1,15.9,16.2l-.3,36.5c-.1,14.5-7.6,21.9-22.3,22.3l-39.1,1,1.3-145.8,33.3-.9c17.3-.5,25.9,8.1,25.7,25.7l-.2,28c0,8.4-4.8,13.7-14.1,15.8v1ZM390.2,164.8l14.6-.4c5.1-.1,7.7-2.3,7.8-6.5l.3-32.3c0-6.9-3.8-10.3-11.5-10.1l-10.8.3-.4,48.9ZM390.8,98.2l9.1-.2c7.4-.2,11.2-3.8,11.2-10.8l.2-22.7c0-7-2.8-10.5-8.6-10.3l-11.6.3-.4,43.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.1,95.4l-.2,17.7-25.6.7-.6,66.2-19.5.5,1.3-145.8,48.3-1.3-.2,17.7-28.8.8-.4,44.3,25.6-.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.7,178.3l-19.5.5,1.1-120.8c.1-16.6,8-25.2,23.5-25.6l14.6-.4c15.5-.4,23.3,7.7,23.1,24.4l-1.1,120.8-19.5.5.5-53.4-22.3.6-.5,53.4ZM569.6,106.7l.4-48.5c0-5.7-2.8-8.5-8.4-8.3h-5.3c-5.7.3-8.5,3.2-8.6,8.9l-.4,48.5,22.3-.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.4,176.9l1.3-145.8,19.5-.5-1.3,145.8-19.5.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.7,30.3l38.1-1c14.9-.4,22.2,7.7,22.1,24.4l-.3,35.9c-.1,12.7-4,20.9-11.8,24.5l13.1,60.3-18.5.5-12.3-58.5-11.8.3-.5,58.9-19.5.5,1.3-145.8ZM654.5,100l12.8-.3c5.8-.2,8.8-3.7,8.8-10.8l.3-31.5c0-7-2.8-10.5-8.6-10.3l-12.8.3-.5,52.6Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.1,235.5l12.6-24.7h.5s12.2,24,12.2,24h-5.1c0,.1-1.9-3.6-1.9-3.6l-11.5.3-1.9,3.9h-5.1ZM158.3,227.3l6.9-.2-3.4-7.3-3.6,7.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.1,235.5l12.6-24.7h.5s12.2,24,12.2,24h-5.1c0,.1-1.9-3.6-1.9-3.6l-11.5.3-1.9,3.9h-5.1ZM158.3,227.3l6.9-.2-3.4-7.3-3.6,7.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.4,210c1.2,0,2.3.2,3.4.6,1,.4,2,1,2.7,1.8.8.8,1.4,1.7,1.8,2.7.4,1,.7,2.2.7,3.4,0,1.2-.2,2.3-.6,3.3-.4,1-1,1.9-1.8,2.7-.8.8-1.8,1.4-3,1.9-1.2.5-2.6.7-4.1.8h-5.4c0,.1,0,7.4,0,7.4h-4.7c0,.1.2-24.2.2-24.2l10.8-.3ZM191.3,222.9c.7,0,1.3-.2,1.8-.4.5-.2.9-.6,1.3-1,.3-.4.6-.9.7-1.4.2-.5.2-1,.2-1.6s0-1.1-.3-1.6-.5-1-.9-1.4c-.4-.4-.8-.7-1.4-1-.6-.3-1.2-.4-1.9-.3h-5.7c0,.1,0,8.9,0,8.9l6.2-.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.4,210c1.2,0,2.3.2,3.4.6,1,.4,2,1,2.7,1.8.8.8,1.4,1.7,1.8,2.7.4,1,.7,2.2.7,3.4,0,1.2-.2,2.3-.6,3.3-.4,1-1,1.9-1.8,2.7-.8.8-1.8,1.4-3,1.9-1.2.5-2.6.7-4.1.8h-5.4c0,.1,0,7.4,0,7.4h-4.7c0,.1.2-24.2.2-24.2l10.8-.3ZM191.3,222.9c.7,0,1.3-.2,1.8-.4.5-.2.9-.6,1.3-1,.3-.4.6-.9.7-1.4.2-.5.2-1,.2-1.6s0-1.1-.3-1.6-.5-1-.9-1.4c-.4-.4-.8-.7-1.4-1-.6-.3-1.2-.4-1.9-.3h-5.7c0,.1,0,8.9,0,8.9l6.2-.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.8,233.8h-4.7c0,.1.2-24.2.2-24.2l11.1-.3c1.2,0,2.4.1,3.4.5,1,.4,1.9.9,2.6,1.7.7.7,1.3,1.6,1.7,2.6.4,1,.6,2.1.6,3.4,0,1.8-.5,3.5-1.4,4.9-.9,1.4-2.2,2.4-3.7,3.1,2,2.7,4,5.3,6,8h-5.6c-1-1.1-1.9-2.3-2.8-3.6-.9-1.3-1.8-2.5-2.8-3.9h-4.6c0,.1,0,7.9,0,7.9ZM210.9,222l6.4-.2c.4,0,.9-.1,1.3-.3.5-.2.9-.4,1.2-.8.4-.4.7-.8.9-1.3.2-.5.4-1.1.4-1.8,0-.4,0-.8-.1-1.3,0-.5-.3-.9-.5-1.4-.3-.4-.6-.8-1.1-1.1-.5-.3-1.1-.4-2-.4l-6.4.2v8.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.8,233.8h-4.7c0,.1.2-24.2.2-24.2l11.1-.3c1.2,0,2.4.1,3.4.5,1,.4,1.9.9,2.6,1.7.7.7,1.3,1.6,1.7,2.6.4,1,.6,2.1.6,3.4,0,1.8-.5,3.5-1.4,4.9-.9,1.4-2.2,2.4-3.7,3.1,2,2.7,4,5.3,6,8h-5.6c-1-1.1-1.9-2.3-2.8-3.6-.9-1.3-1.8-2.5-2.8-3.9h-4.6c0,.1,0,7.9,0,7.9ZM210.9,222l6.4-.2c.4,0,.9-.1,1.3-.3.5-.2.9-.4,1.2-.8.4-.4.7-.8.9-1.3.2-.5.4-1.1.4-1.8,0-.4,0-.8-.1-1.3,0-.5-.3-.9-.5-1.4-.3-.4-.6-.8-1.1-1.1-.5-.3-1.1-.4-2-.4l-6.4.2v8.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.2,233.1h-4.7c0,.1.2-24.2.2-24.2h4.7c0-.1-.2,24.2-.2,24.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M238.2,233.1h-4.7c0,.1.2-24.2.2-24.2h4.7c0-.1-.2,24.2-.2,24.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.6,228.3v4.1s-17.6.5-17.6.5l.2-24.4h4.7c0-.1-.2,20.1-.2,20.1l12.9-.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M264.6,228.3v4.1s-17.6.5-17.6.5l.2-24.4h4.7c0-.1-.2,20.1-.2,20.1l12.9-.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.1,227.3v4.1s-16.9.4-16.9.4v-4.6c.5-.4,1-.9,1.8-1.5.7-.6,1.5-1.3,2.3-2,.8-.7,1.7-1.4,2.5-2.1.8-.7,1.6-1.3,2.2-1.9.7-.6,1.3-1.2,1.8-1.7.4-.5.8-.9,1-1.4.2-.4.4-.8.4-1.2,0-.4,0-.8,0-1.1,0-.7-.1-1.2-.3-1.6-.2-.4-.5-.8-.9-1-.4-.3-.8-.4-1.2-.5-.5,0-.9-.1-1.3-.1-.8,0-1.4.2-1.9.6-.5.4-.9.8-1.2,1.3-.3.5-.5.9-.7,1.3-.1.4-.2.7-.3.8h0s-4.5-1.1-4.5-1.1c.2-.6.4-1.3.9-2.1.4-.8,1-1.6,1.7-2.3.7-.7,1.5-1.3,2.5-1.8s2.2-.8,3.5-.8c1.4,0,2.7.2,3.8.6,1.1.4,1.9,1,2.6,1.7.7.7,1.2,1.5,1.5,2.4.3.9.5,1.8.5,2.7,0,.9-.1,1.8-.4,2.6s-.6,1.5-1,2.2c-.5.7-1,1.4-1.6,2-.6.7-1.4,1.3-2.2,2-.3.3-.7.6-1.1.9s-.9.7-1.3,1.1c-.5.4-1,.8-1.5,1.2-.5.4-1,.8-1.5,1.2l10.8-.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.1,227.3v4.1s-16.9.4-16.9.4v-4.6c.5-.4,1-.9,1.8-1.5.7-.6,1.5-1.3,2.3-2,.8-.7,1.7-1.4,2.5-2.1.8-.7,1.6-1.3,2.2-1.9.7-.6,1.3-1.2,1.8-1.7.4-.5.8-.9,1-1.4.2-.4.4-.8.4-1.2,0-.4,0-.8,0-1.1,0-.7-.1-1.2-.3-1.6-.2-.4-.5-.8-.9-1-.4-.3-.8-.4-1.2-.5-.5,0-.9-.1-1.3-.1-.8,0-1.4.2-1.9.6-.5.4-.9.8-1.2,1.3-.3.5-.5.9-.7,1.3-.1.4-.2.7-.3.8h0s-4.5-1.1-4.5-1.1c.2-.6.4-1.3.9-2.1.4-.8,1-1.6,1.7-2.3.7-.7,1.5-1.3,2.5-1.8s2.2-.8,3.5-.8c1.4,0,2.7.2,3.8.6,1.1.4,1.9,1,2.6,1.7.7.7,1.2,1.5,1.5,2.4.3.9.5,1.8.5,2.7,0,.9-.1,1.8-.4,2.6s-.6,1.5-1,2.2c-.5.7-1,1.4-1.6,2-.6.7-1.4,1.3-2.2,2-.3.3-.7.6-1.1.9s-.9.7-1.3,1.1c-.5.4-1,.8-1.5,1.2-.5.4-1,.8-1.5,1.2l10.8-.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.4,218.7c.4.1.9.3,1.4.6s.9.6,1.3,1c.4.4.7,1,.9,1.6.2.6.4,1.4.3,2.3,0,.2,0,.5,0,.8,0,.3-.1.7-.2,1.1-.1.4-.3.8-.4,1.2-.2.4-.4.8-.8,1.2-.5.6-1,1.1-1.6,1.5-.6.4-1.2.7-1.8.9-.6.2-1.3.4-1.9.5-.6,0-1.2.1-1.8.2-1.4,0-2.6-.2-3.6-.6-1-.5-1.8-1-2.5-1.7-.6-.7-1.2-1.4-1.5-2.2-.4-.8-.6-1.4-.8-2l4.5-1.4c0,0,0,.3.2.8,0,.4.3.9.5,1.3.3.5.7.9,1.2,1.2.5.4,1.2.5,2.1.5,1.3,0,2.2-.4,2.9-1,.6-.6,1-1.3,1-2.1,0-.8-.1-1.5-.4-2-.3-.5-.6-.9-1.2-1.2-.5-.3-1.1-.5-1.9-.5-.8,0-1.6-.1-2.6-.1v-3.6c1,0,1.8-.2,2.6-.3.8,0,1.4-.3,1.9-.5.5-.3.9-.6,1.2-1.1.3-.5.4-1.1.4-1.9,0-.8-.3-1.5-.9-2-.6-.6-1.6-.8-2.9-.8-.9,0-1.6.2-2.1.6-.5.4-.9.8-1.2,1.3-.3.5-.5.9-.6,1.3,0,.4-.2.7-.2.8l-4.4-1.2c.2-.6.4-1.3.8-2.1.4-.8.9-1.5,1.6-2.3.7-.7,1.5-1.3,2.5-1.8,1-.5,2.2-.8,3.6-.8,1.6,0,2.9.1,4,.5s2,.9,2.6,1.6c.7.7,1.1,1.4,1.4,2.2.3.8.4,1.6.4,2.5,0,.9-.1,1.7-.4,2.3-.2.6-.6,1.1-.9,1.6-.4.4-.8.8-1.3,1.1-.5.3-.9.5-1.4.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.4,218.7c.4.1.9.3,1.4.6s.9.6,1.3,1c.4.4.7,1,.9,1.6.2.6.4,1.4.3,2.3,0,.2,0,.5,0,.8,0,.3-.1.7-.2,1.1-.1.4-.3.8-.4,1.2-.2.4-.4.8-.8,1.2-.5.6-1,1.1-1.6,1.5-.6.4-1.2.7-1.8.9-.6.2-1.3.4-1.9.5-.6,0-1.2.1-1.8.2-1.4,0-2.6-.2-3.6-.6-1-.5-1.8-1-2.5-1.7-.6-.7-1.2-1.4-1.5-2.2-.4-.8-.6-1.4-.8-2l4.5-1.4c0,0,0,.3.2.8,0,.4.3.9.5,1.3.3.5.7.9,1.2,1.2.5.4,1.2.5,2.1.5,1.3,0,2.2-.4,2.9-1,.6-.6,1-1.3,1-2.1,0-.8-.1-1.5-.4-2-.3-.5-.6-.9-1.2-1.2-.5-.3-1.1-.5-1.9-.5-.8,0-1.6-.1-2.6-.1v-3.6c1,0,1.8-.2,2.6-.3.8,0,1.4-.3,1.9-.5.5-.3.9-.6,1.2-1.1.3-.5.4-1.1.4-1.9,0-.8-.3-1.5-.9-2-.6-.6-1.6-.8-2.9-.8-.9,0-1.6.2-2.1.6-.5.4-.9.8-1.2,1.3-.3.5-.5.9-.6,1.3,0,.4-.2.7-.2.8l-4.4-1.2c.2-.6.4-1.3.8-2.1.4-.8.9-1.5,1.6-2.3.7-.7,1.5-1.3,2.5-1.8,1-.5,2.2-.8,3.6-.8,1.6,0,2.9.1,4,.5s2,.9,2.6,1.6c.7.7,1.1,1.4,1.4,2.2.3.8.4,1.6.4,2.5,0,.9-.1,1.7-.4,2.3-.2.6-.6,1.1-.9,1.6-.4.4-.8.8-1.3,1.1-.5.3-.9.5-1.4.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.5,228c.1.6.2,1.3,0,2s-.3,1.4-.7,2c-.4.6-.8,1.2-1.4,1.6-.6.5-1.3.8-2.1,1l-.6-1.2c.7-.2,1.3-.6,1.6-1,.4-.4.6-.9.7-1.5-.7,0-1.2-.2-1.7-.6-.5-.4-.7-1-.8-1.7,0-.7.2-1.3.6-1.8.5-.5,1-.8,1.7-.8.6,0,1.2.1,1.6.5.5.4.8.9.9,1.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.5,228c.1.6.2,1.3,0,2s-.3,1.4-.7,2c-.4.6-.8,1.2-1.4,1.6-.6.5-1.3.8-2.1,1l-.6-1.2c.7-.2,1.3-.6,1.6-1,.4-.4.6-.9.7-1.5-.7,0-1.2-.2-1.7-.6-.5-.4-.7-1-.8-1.7,0-.7.2-1.3.6-1.8.5-.5,1-.8,1.7-.8.6,0,1.2.1,1.6.5.5.4.8.9.9,1.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.1,209.3l-6.9.2-.2,20.2h-4.7c0,.1.2-20.1.2-20.1l-7,.2v-4.1s18.6-.5,18.6-.5v4.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.1,209.3l-6.9.2-.2,20.2h-4.7c0,.1.2-20.1.2-20.1l-7,.2v-4.1s18.6-.5,18.6-.5v4.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.5,204.4l-.2,24.4h-4.7c0,.1,0-9.6,0-9.6l-12,.3v9.7c0,0-4.7.1-4.7.1l.2-24.4h4.7c0-.1,0,10.4,0,10.4l12-.3v-10.5c0,0,4.7-.1,4.7-.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.5,204.4l-.2,24.4h-4.7c0,.1,0-9.6,0-9.6l-12,.3v9.7c0,0-4.7.1-4.7.1l.2-24.4h4.7c0-.1,0,10.4,0,10.4l12-.3v-10.5c0,0,4.7-.1,4.7-.1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.5,228.5h-4.7c0,.1.2-24.2.2-24.2l11.1-.3c1.2,0,2.4.1,3.4.5,1,.4,1.9.9,2.6,1.7.7.7,1.3,1.6,1.7,2.6.4,1,.6,2.1.6,3.4,0,1.8-.5,3.5-1.4,4.9-.9,1.4-2.2,2.4-3.7,3.1,2,2.7,4,5.3,6,8h-5.6c-1-1.1-1.9-2.3-2.8-3.6-.9-1.3-1.8-2.5-2.8-3.9h-4.6c0,.1,0,7.9,0,7.9ZM416.6,216.6l6.4-.2c.4,0,.9-.1,1.3-.3.5-.2.9-.4,1.2-.8.4-.4.7-.8.9-1.3.2-.5.4-1.1.4-1.8,0-.4,0-.8-.1-1.3s-.3-.9-.5-1.4c-.3-.4-.6-.8-1.1-1.1-.5-.3-1.1-.4-2-.4l-6.4.2v8.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.5,228.5h-4.7c0,.1.2-24.2.2-24.2l11.1-.3c1.2,0,2.4.1,3.4.5,1,.4,1.9.9,2.6,1.7.7.7,1.3,1.6,1.7,2.6.4,1,.6,2.1.6,3.4,0,1.8-.5,3.5-1.4,4.9-.9,1.4-2.2,2.4-3.7,3.1,2,2.7,4,5.3,6,8h-5.6c-1-1.1-1.9-2.3-2.8-3.6-.9-1.3-1.8-2.5-2.8-3.9h-4.6c0,.1,0,7.9,0,7.9ZM416.6,216.6l6.4-.2c.4,0,.9-.1,1.3-.3.5-.2.9-.4,1.2-.8.4-.4.7-.8.9-1.3.2-.5.4-1.1.4-1.8,0-.4,0-.8-.1-1.3s-.3-.9-.5-1.4c-.3-.4-.6-.8-1.1-1.1-.5-.3-1.1-.4-2-.4l-6.4.2v8.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.9,227.7h-4.7c0,.1.2-24.2.2-24.2h4.7c0-.1-.2,24.2-.2,24.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M443.9,227.7h-4.7c0,.1.2-24.2.2-24.2h4.7c0-.1-.2,24.2-.2,24.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.7,224.3l2.6-3.8c1.2.8,2.5,1.5,3.8,2.1,1.3.6,2.6.8,4.1.8.8,0,1.4-.1,2-.3.6-.2,1.1-.5,1.5-.8.4-.3.7-.7.9-1.1s.3-.8.3-1.2c0-.5-.1-.9-.4-1.2-.3-.3-.7-.6-1.2-.8-.5-.2-1.1-.4-1.8-.5-.7-.1-1.4-.3-2.1-.4-.5,0-1.1-.2-1.7-.3-.6-.1-1.3-.3-2-.4-.7-.2-1.4-.5-2-.8-.7-.3-1.3-.7-1.8-1.2-.5-.5-.9-1.1-1.3-1.8-.3-.7-.5-1.6-.5-2.5,0-1.4.3-2.6.9-3.6.6-1,1.3-1.7,2.2-2.3.9-.6,1.9-1,3-1.2,1.1-.2,2.2-.4,3.2-.4,1,0,1.9,0,2.7.1.8.1,1.5.3,2.2.5s1.4.5,2,.9c.6.4,1.3.8,2.1,1.3l-2.6,3.7c-1.1-.8-2.2-1.3-3.3-1.7s-2.2-.6-3.4-.5c-.4,0-.9,0-1.4.2-.5.1-1,.3-1.5.5s-.8.5-1.1.9c-.3.4-.5.8-.5,1.3s.2.9.5,1.2.8.6,1.4.8c.6.2,1.2.4,1.8.5.7.1,1.3.3,1.9.4.5,0,1,.2,1.6.3.6,0,1.3.2,2,.4.7.2,1.3.4,2,.7.7.3,1.3.7,1.8,1.2s.9,1.1,1.2,1.9c.3.8.5,1.7.5,2.8,0,1.3-.2,2.4-.7,3.3s-1.1,1.7-1.9,2.4-1.8,1.1-2.9,1.5c-1.1.3-2.4.5-3.8.6-1.3,0-2.4,0-3.3-.2-1-.2-1.8-.4-2.6-.7s-1.5-.7-2.3-1.1c-.7-.4-1.4-.9-2.2-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M451.7,224.3l2.6-3.8c1.2.8,2.5,1.5,3.8,2.1,1.3.6,2.6.8,4.1.8.8,0,1.4-.1,2-.3.6-.2,1.1-.5,1.5-.8.4-.3.7-.7.9-1.1s.3-.8.3-1.2c0-.5-.1-.9-.4-1.2-.3-.3-.7-.6-1.2-.8-.5-.2-1.1-.4-1.8-.5-.7-.1-1.4-.3-2.1-.4-.5,0-1.1-.2-1.7-.3-.6-.1-1.3-.3-2-.4-.7-.2-1.4-.5-2-.8-.7-.3-1.3-.7-1.8-1.2-.5-.5-.9-1.1-1.3-1.8-.3-.7-.5-1.6-.5-2.5,0-1.4.3-2.6.9-3.6.6-1,1.3-1.7,2.2-2.3.9-.6,1.9-1,3-1.2,1.1-.2,2.2-.4,3.2-.4,1,0,1.9,0,2.7.1.8.1,1.5.3,2.2.5s1.4.5,2,.9c.6.4,1.3.8,2.1,1.3l-2.6,3.7c-1.1-.8-2.2-1.3-3.3-1.7s-2.2-.6-3.4-.5c-.4,0-.9,0-1.4.2-.5.1-1,.3-1.5.5s-.8.5-1.1.9c-.3.4-.5.8-.5,1.3s.2.9.5,1.2.8.6,1.4.8c.6.2,1.2.4,1.8.5.7.1,1.3.3,1.9.4.5,0,1,.2,1.6.3.6,0,1.3.2,2,.4.7.2,1.3.4,2,.7.7.3,1.3.7,1.8,1.2s.9,1.1,1.2,1.9c.3.8.5,1.7.5,2.8,0,1.3-.2,2.4-.7,3.3s-1.1,1.7-1.9,2.4-1.8,1.1-2.9,1.5c-1.1.3-2.4.5-3.8.6-1.3,0-2.4,0-3.3-.2-1-.2-1.8-.4-2.6-.7s-1.5-.7-2.3-1.1c-.7-.4-1.4-.9-2.2-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477,223.7l2.6-3.8c1.2.8,2.5,1.5,3.8,2.1s2.6.8,4.1.8c.8,0,1.4-.1,2-.3.6-.2,1.1-.5,1.5-.8.4-.3.7-.7.9-1.1.2-.4.3-.8.3-1.2,0-.5-.1-.9-.4-1.2-.3-.3-.7-.6-1.2-.8-.5-.2-1.1-.4-1.8-.5-.7-.1-1.4-.3-2.1-.4-.5,0-1.1-.2-1.7-.3s-1.3-.3-2-.4c-.7-.2-1.4-.5-2-.8-.7-.3-1.3-.7-1.8-1.3-.5-.5-.9-1.1-1.3-1.8-.3-.7-.5-1.6-.5-2.5,0-1.4.3-2.6.9-3.6s1.3-1.7,2.2-2.3c.9-.6,1.9-1,3-1.2,1.1-.2,2.2-.4,3.2-.4,1,0,1.9,0,2.7.1s1.5.3,2.2.5,1.4.5,2,.9c.6.4,1.3.8,2.1,1.3l-2.6,3.7c-1.1-.8-2.2-1.3-3.3-1.7-1.1-.4-2.2-.6-3.4-.5-.4,0-.9,0-1.4.2-.5.1-1,.3-1.5.5-.5.2-.8.5-1.1.9-.3.4-.5.8-.5,1.3,0,.5.2.9.5,1.2s.8.6,1.4.8c.6.2,1.2.4,1.8.5.7.1,1.3.3,1.9.4.5,0,1,.2,1.6.3.6,0,1.3.2,2,.4.7.2,1.3.4,2,.7s1.3.7,1.8,1.2c.5.5.9,1.1,1.2,1.9.3.8.5,1.7.5,2.8,0,1.3-.2,2.4-.7,3.3-.5.9-1.1,1.7-1.9,2.4-.8.6-1.8,1.1-2.9,1.5s-2.4.5-3.8.6c-1.3,0-2.4,0-3.3-.2-1-.2-1.8-.4-2.6-.7-.8-.3-1.5-.7-2.3-1.1s-1.4-.9-2.2-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M477,223.7l2.6-3.8c1.2.8,2.5,1.5,3.8,2.1s2.6.8,4.1.8c.8,0,1.4-.1,2-.3.6-.2,1.1-.5,1.5-.8.4-.3.7-.7.9-1.1.2-.4.3-.8.3-1.2,0-.5-.1-.9-.4-1.2-.3-.3-.7-.6-1.2-.8-.5-.2-1.1-.4-1.8-.5-.7-.1-1.4-.3-2.1-.4-.5,0-1.1-.2-1.7-.3s-1.3-.3-2-.4c-.7-.2-1.4-.5-2-.8-.7-.3-1.3-.7-1.8-1.3-.5-.5-.9-1.1-1.3-1.8-.3-.7-.5-1.6-.5-2.5,0-1.4.3-2.6.9-3.6s1.3-1.7,2.2-2.3c.9-.6,1.9-1,3-1.2,1.1-.2,2.2-.4,3.2-.4,1,0,1.9,0,2.7.1s1.5.3,2.2.5,1.4.5,2,.9c.6.4,1.3.8,2.1,1.3l-2.6,3.7c-1.1-.8-2.2-1.3-3.3-1.7-1.1-.4-2.2-.6-3.4-.5-.4,0-.9,0-1.4.2-.5.1-1,.3-1.5.5-.5.2-.8.5-1.1.9-.3.4-.5.8-.5,1.3,0,.5.2.9.5,1.2s.8.6,1.4.8c.6.2,1.2.4,1.8.5.7.1,1.3.3,1.9.4.5,0,1,.2,1.6.3.6,0,1.3.2,2,.4.7.2,1.3.4,2,.7s1.3.7,1.8,1.2c.5.5.9,1.1,1.2,1.9.3.8.5,1.7.5,2.8,0,1.3-.2,2.4-.7,3.3-.5.9-1.1,1.7-1.9,2.4-.8.6-1.8,1.1-2.9,1.5s-2.4.5-3.8.6c-1.3,0-2.4,0-3.3-.2-1-.2-1.8-.4-2.6-.7-.8-.3-1.5-.7-2.3-1.1s-1.4-.9-2.2-1.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.9,226.3c-1.6,0-3-.2-4.3-.6-1.3-.5-2.4-1.1-3.3-2-.9-.9-1.6-1.9-2.1-3.2-.5-1.3-.7-2.7-.7-4.2v-14.5c.1,0,4.8-.1,4.8-.1v14.5c-.1,1.2,0,2.2.4,3,.4.8.9,1.4,1.5,1.9.6.5,1.2.8,1.9.9.7.2,1.3.2,1.8.2s1.1-.1,1.8-.3c.7-.2,1.3-.5,1.9-1,.6-.5,1.1-1.1,1.5-1.9s.6-1.8.6-3v-14.5c.1,0,4.8-.1,4.8-.1v14.5c-.1,1.6-.4,3-.9,4.2-.5,1.3-1.2,2.4-2.1,3.3-.9.9-2,1.6-3.3,2.1-1.3.5-2.7.8-4.3.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M513.9,226.3c-1.6,0-3-.2-4.3-.6-1.3-.5-2.4-1.1-3.3-2-.9-.9-1.6-1.9-2.1-3.2-.5-1.3-.7-2.7-.7-4.2v-14.5c.1,0,4.8-.1,4.8-.1v14.5c-.1,1.2,0,2.2.4,3,.4.8.9,1.4,1.5,1.9.6.5,1.2.8,1.9.9.7.2,1.3.2,1.8.2s1.1-.1,1.8-.3c.7-.2,1.3-.5,1.9-1,.6-.5,1.1-1.1,1.5-1.9s.6-1.8.6-3v-14.5c.1,0,4.8-.1,4.8-.1v14.5c-.1,1.6-.4,3-.9,4.2-.5,1.3-1.2,2.4-2.1,3.3-.9.9-2,1.6-3.3,2.1-1.3.5-2.7.8-4.3.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537.5,225.3h-4.7c0,.1.2-24.2.2-24.2l11.1-.3c1.2,0,2.4.1,3.4.5,1,.4,1.9.9,2.6,1.7.7.7,1.3,1.6,1.7,2.6.4,1,.6,2.1.6,3.4,0,1.8-.5,3.5-1.4,4.9-.9,1.4-2.2,2.4-3.7,3.1,2,2.7,4,5.3,6,8h-5.6c-1-1.1-1.9-2.3-2.8-3.6-.9-1.3-1.8-2.5-2.8-3.9h-4.6c0,.1,0,7.9,0,7.9ZM537.6,213.4l6.4-.2c.4,0,.9-.1,1.3-.3.5-.2.9-.4,1.2-.8.4-.4.7-.8.9-1.3.2-.5.4-1.1.4-1.8,0-.4,0-.8-.1-1.3,0-.5-.3-.9-.5-1.4-.3-.4-.6-.8-1.1-1.1-.5-.3-1.1-.4-2-.4l-6.4.2v8.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M537.5,225.3h-4.7c0,.1.2-24.2.2-24.2l11.1-.3c1.2,0,2.4.1,3.4.5,1,.4,1.9.9,2.6,1.7.7.7,1.3,1.6,1.7,2.6.4,1,.6,2.1.6,3.4,0,1.8-.5,3.5-1.4,4.9-.9,1.4-2.2,2.4-3.7,3.1,2,2.7,4,5.3,6,8h-5.6c-1-1.1-1.9-2.3-2.8-3.6-.9-1.3-1.8-2.5-2.8-3.9h-4.6c0,.1,0,7.9,0,7.9ZM537.6,213.4l6.4-.2c.4,0,.9-.1,1.3-.3.5-.2.9-.4,1.2-.8.4-.4.7-.8.9-1.3.2-.5.4-1.1.4-1.8,0-.4,0-.8-.1-1.3,0-.5-.3-.9-.5-1.4-.3-.4-.6-.8-1.1-1.1-.5-.3-1.1-.4-2-.4l-6.4.2v8.4Z"
  })))), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 141.7,
    y1: 34.5,
    x2: 693.7,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 9.9,
    y1: 35,
    x2: 61.7,
    y2: 33.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137,18.1l-39.9-11.8c-.5-.2-1.1-.2-1.7,0l-40.1,13.6c-1,.3-1.7,1.2-1.7,2.1,0,1,.7,1.8,1.6,2.1l39.9,11.9c.3,0,.6.1.8.1s.6,0,.8-.2l40.1-13.7c1-.3,1.7-1.2,1.7-2.2s-.6-1.8-1.6-2.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.4,47l.2-19.6-5,1.7-.2,18c-1.5.8-2.5,2.3-2.5,4,0,1.7,1,3.1,2.5,3.8v11c-.1,1.2,1,2.2,2.4,2.2,1.4,0,2.5-1.1,2.5-2.3v-11c1.6-.8,2.6-2.3,2.6-4,0-1.7-1-3.1-2.5-3.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96,39.5c-.8,0-1.7,0-2.5-.3l-22.4-6.7v9.9c-.1,2.4,2.7,4.4,8.2,5.9,4.8,1.3,10.7,1.9,16.7,1.8,5.9-.1,11.9-1,16.7-2.6,5.5-1.7,8.3-3.8,8.4-6.3v-9.9c0,0-22.5,7.7-22.5,7.7-.8.3-1.7.4-2.5.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduJobFair);
export default __webpack_public_path__ + "static/media/EduJobFair.8cf9841288dd771f6c564ee9ece94220.svg";
export { ForwardRef as ReactComponent };